import React, { useEffect, useMemo } from 'react';
import { Page, Text, View, Image, Document, StyleSheet } from '@react-pdf/renderer';
import logonfh from '../../../assets/images/logonfh.png'


const styles = StyleSheet.create({
    page: {
        flexDirection: 'row',
        flexWrap: "wrap",
        backgroundColor: '#ffffff',
        paddingTop: 35,
        paddingBottom: 37,
        paddingLeft: '10px'
    },
    image: {
        width: '80%',
        marginBottom: 3
    },
    imageQr: {
        width: "90px",
        marginTop: 5
    },
    sectionQr: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-around",
    },
    section: {
        display: "flex",
        flexDirection: "column",
        marginTop: '0.5px',
        marginRight: '12px',
        //marginLeft: '1px',
        padding: 2,
        width: "4in",
        height: "2in",
        borderRadius: 6,
        backgroundColor: "#a7c5eb"
    },
    infoProduct: {
        width: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "flex-start",
        marginLeft: 10
    },
    titleProduct: {
        width: "3.8in",
        fontSize: 12
    },
    medidaProduct: {
        fontSize: 12,
        marginTop: 5
    },
    precioProduct: {
        fontSize: 22,
        fontWeight: 600
    },
    containerName: {
        width: "100%"
    }

});

function returnSrc(uri) {
    const path = uri
    const selectedMethod = 'GET' 
    return { uri: path, method: selectedMethod, body: '', headers: '' }; 
  }


const GeneratePDF = ({ productos }) => {
    
    const file = useMemo(() => ({ productos }), [productos]);

    if (!file.productos && file.productos.length < 0) {
        return null
    }
    else {
        console.log(file)
        return (
            <Document file={file}>
                <Page size="letter" style={styles.page} wrap>
                    {file.productos && file.productos.length > 0 &&
                        file.productos.map((item) =>
                            <View style={styles.section} key={item.id}>
                                {/* <View style={styles.image}>
                                    <Image src={logonfh} />
                                </View> */}
                                <View style={styles.infoProduct}>
                                    <View style={styles.containerName}>
                                        <Text style={styles.titleProduct}>{item.nombre_producto}</Text>
                                    </View>
                                    <Text style={styles.medidaProduct}>Id material: {item.clave_producto}</Text>
                                </View>
                                <View style={styles.sectionQr}>
                                    <View style={styles.imageQr}>
                                        {/* {item.qr_product_url && <Image src={item.qr_product_url} allowDangerousPaths />} */}
                                        <Image src={`https://chart.googleapis.com/chart?chs=150x150&cht=qr&chl=https://nfhpanel.web.app/productos/${item.id}&choe=UTF-8`}/>
                                        
                                    </View>
                                    <View style={styles.imageQr}>
                                        {item.image_product && item.image_product.length > 0 && <Image src={returnSrc(item.image_product[0].image_product)} cache={false} allowDangerousPaths/>}  
                                     

                                        {/* <Image src="https://nacinalferreteradehidalgo.space/exp/productos/010150/010150_xsenqD1.jpg" allowDangerousPaths/> */}
                                        {/* <Image src={item.image_product[0].image_product}
                                         source={{
                                             uri:item.image_product[0].image_product,
                                             method: 'GET',
                                            headers: { 'Cache-Control': 'no-cache', 'Access-Control-Allow-Origin': '*' },
                                        }} /> */}
                                    </View>
                                </View>
                            </View>
                        )
                    }
                </Page>
            </Document>
        );
    }

};

export default GeneratePDF;